import type { PropsWithChildren } from "react";

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/shared/ui/hover-card.tsx";
import type { IHoverCardInfo } from "./types.ts";
import { cn } from "@/shared/lib/utils.ts";

const contentInfo: Record<string, string> = {
  Изменен: "Дата и время последнего изменения записи.",
  "Последний звонок": "Дата и время последнего звонка с пользователем.",
  Создано: "Дата и время создания записи.",
  "Дата запроса": "Дата, когда пользователь сделал запрос.",
  "Начало тренировки": "Дата и время начала тренировки пользователя.",
  Зашел: "Дата и время последнего входа пользователя.",
  "Количество лидов": "Количество привлеченных пользователем лидов.",
  Прибыль: "Прибыль, полученная от пользователя.",
  Тип: "Тип пользователя или записи (например, студент, менеджер).",
  Ссылка: "Ссылка на профиль пользователя или дополнительную информацию.",
  Нинкнейм: "Псевдоним пользователя.",
  Имя: "Полное имя пользователя.",
  Статус: "Текущий статус пользователя (например, активный, неактивный).",
  "Зароботок с ученика":
    "Заработок, полученный от обучения конкретного ученика.",
  "Без куратора": "Флаг, указывающий, есть ли куратор у лида.",
  "Был звонок": "Флаг, указывающий, был ли совершен звонок пользователю.",
  Крутит:
    "Флаг, указывающий, что пользователь активно работает (например, в данный момент выполняет задачу).",
  Отклонен:
    "Флаг, указывающий, что запрос или заявка пользователя были отклонены.",
  "Прошел опрос": "Флаг, указывающий, что пользователь прошел опрос.",
  Отписал: "Флаг, указывающий, что пользователь отправил сообщение.",
  Отвязан: "Не имеет куратора",
  Деп: "Сумма депозита пользователя.",
  Менеджер: "Имя менеджера, ответственного за пользователя.",
  Куратор: "Имя куратора, ответственного за пользователя.",
  Тимлид: "Имя тимлида, ответственного за пользователя.",
  Руководитель: "Имя руководителя, ответственного за пользователя.",
  Модератор: "Имя модератора, ответственного за пользователя.",
  Воркер: "Имя воркера, ответственного за пользователя.",
  ignore: "Флаг, указывающий, что пользователь игнорирует",
  Игнорит: "Флаг, указывающий, что пользователь игнорирует",
  "Прошёл опрос": "Флаг, указывающий, что пользователь прошёл опрос",
  Дэп: "Флаг, указывающий, что пользователь сделал дэп",
  "Опрос не пройден": "Флаг, указывающий, что опрос не пройден",
  Греется: "Флаг, указывающий, что пользователь греется",
  "Не прошел опрос":
    "Флаг, указывающий , что пользователь еще не приступил к прохождению опроса",
  Активен: "Флаг, указывающий, что пользователь активен",
  Заблокирован: "Флаг, указывающий, что пользователь заблокирован",
  "В поисках депозита": "Флаг, указывающий, что пользователь ищет депозит",
};

export const HoverCardInfo = ({
  children,
  text,
  className,
}: PropsWithChildren<IHoverCardInfo>) => {
  return (
    <HoverCard>
      <HoverCardTrigger>
        <p className={cn("text-center", className)}>{children}</p>
      </HoverCardTrigger>
      <HoverCardContent>{contentInfo[text]}</HoverCardContent>
    </HoverCard>
  );
};
